import { ReactNode } from "react";
import cx from "classnames";

import { useTransition } from "common/hooks";
import { stopPropagation } from "common/utils";

import Overlay from "client/common/components/stackables/Overlay";

import styles from "../styles/ConsentDialog.module.less";

interface ConsentDialogProps {
  children: ReactNode;
  onClose: () => void;
}

/**
 * This component is a copy of the Dialog component from the common package.
 * It required custom styles to be applied to the overlay.
 */
const ConsentDialog = ({ children, onClose }: ConsentDialogProps) => {
  const transition = useTransition(true);
  const { transitionState, durationStyle } = transition;

  return (
    <Overlay
      isFocused={true}
      isVisible={true}
      onClose={onClose}
      transition={transition}
      className={styles.container}
    >
      <div
        className={cx(styles.box, styles[`transition-${transitionState}`])}
        onMouseDown={stopPropagation}
        onClick={stopPropagation}
        role="presentation"
        style={{ transitionDuration: durationStyle }}
      >
        {children}
      </div>
    </Overlay>
  );
};

export default ConsentDialog;
